import React from "react";

export const FileV2Svg = (props) => {
	const { width = 13, height = 16, color = '#1DBD6B', ...rest } = props;
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 13 16"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3.532.917H9.47c2.188 0 3.406 1.26 3.406 3.421v7.317c0 2.196-1.218 3.429-3.406 3.429H3.532c-2.153 0-3.407-1.233-3.407-3.429V4.338c0-2.16 1.254-3.421 3.407-3.421m.192 3.302v-.007H5.84a.555.555 0 0 1 0 1.112H3.724a.553.553 0 0 1 0-1.105m0 4.306h5.553a.553.553 0 0 0 0-1.106H3.724a.553.553 0 0 0 0 1.106m0 3.237h5.553a.554.554 0 0 0 .496-.553.556.556 0 0 0-.496-.56H3.724a.563.563 0 0 0-.531.857.55.55 0 0 0 .53.256"
        clipRule="evenodd"
      ></path>
    </svg>
	)
}
